import React from "react";
import { useTranslation } from 'react-i18next';
import ResetPasswordForm from "../../../containers/user-management/ResetPasswordForm/ResetPasswordForm";
import {
  Wrapper,
  Header,
  Title,
  SubTitle,
  Card,
  Logo,
} from "../styles";
import PageWrapper from "../../../components/PageWrapper/PageWrapper";
import LanguageDropdown from "../../../components/LanguageDropdown";

const ResetPasswordPage = () => {
  const { t } = useTranslation();
  return (
    <PageWrapper>
      <LanguageDropdown />
    <Wrapper>
      <Header>
        <Logo src="/logo.png" alt="Offolio Logo" />
        <SubTitle>{t('resetPasswordPage.title')}</SubTitle>
          <p>{t('resetPasswordPage.subtitle')}</p>
      </Header>

      <Card>
        <ResetPasswordForm/>
      </Card>
    </Wrapper>
    </PageWrapper>
  );
};

export default ResetPasswordPage;
